import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaHandshake,
  FaMedal,
  FaShieldAlt,
  FaBullhorn,
  FaBullseye,
  FaEye,
} from 'react-icons/fa';
import { FaLinkedinIn } from 'react-icons/fa6';
import './About.css';


/* DATA */

const CORE_VALUES = [
  {
    icon: <FaHandshake size={22} color="#0EA5E9" />,
    title: 'Collaboration',
    text: 'Fostering teamwork and knowledge sharing both locally and internationally to accelerate Kenya\'s nuclear development.',
  },
  {
    icon: <FaMedal size={22} color="#F59E0B" />,
    title: 'Excellence',
    text: 'Supporting top-level education, rigorous training, and high standards of professional practice across all nuclear fields.',
  },
  {
    icon: <FaShieldAlt size={22} color="#22C55E" />,
    title: 'Safety',
    text: 'Advocating for evidence-based policies, strict regulatory compliance, and a safety-first culture throughout the nuclear sector.',
  },
  {
    icon: <FaBullhorn size={22} color="#EF4444" />,
    title: 'Awareness',
    text: 'Enhancing public understanding of nuclear science and technology through outreach, dialogue, and transparent communication.',
  },
];

const GOALS = [
  {
    label: 'Connect Professionals',
    desc: 'Bringing together scientists, engineers, students, and policymakers through networking events, conferences, and workshops.',
  },
  {
    label: 'Inform Policy',
    desc: 'Helping the government design sound, science-based regulatory frameworks and policies for Kenya\'s nuclear sector.',
  },
  {
    label: 'Build Partnerships',
    desc: 'Collaborating with national bodies such as NuPEA and KNRA, and international organisations including the IAEA.',
  },
];

const AFFILIATIONS = [
  { label: 'IAEA',    href: 'http://www.iaea.org/'       },
  { label: 'NuPEA',   href: 'https://www.nuclear.co.ke/'    },
  { label: 'KNRA',    href: 'https://knra.co.ke/'     },
  { label: 'KenGen',  href: 'https://www.kengen.co.ke/'   },
  { label: 'NACOSTI', href: 'https://www.nacosti.go.ke/'  },
];

/* ABOUT PAGE */
function About() {
  return (
    <>
      {/* Page Hero */}
      <section className="about-hero" aria-labelledby="about-hero-heading">
        <div className="about-hero__inner">
          <nav className="about-hero__breadcrumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span className="about-hero__breadcrumb-sep" aria-hidden="true">›</span>
            <span>About NSK</span>
          </nav>

          <h1 className="about-hero__title" id="about-hero-heading">
            About the Nuclear Society of Kenya
          </h1>

          <p className="about-hero__lead">
            A professional, non-profit organisation uniting scientists, engineers,
            students, and the public to promote the peaceful use of nuclear science
            and technology for Kenya's economic and social advancement.
          </p>
        </div>
      </section>

      {/* Founding President's Message */}
      <section className="president-msg" aria-labelledby="president-heading">
        <div className="president-msg__inner">

          {/* Profile sidebar */}
          <div className="president-msg__profile">
            {
              <img
                src={require('../../assets/images/president.png')}
                alt="Founding President of NSK"
                className="president-msg__avatar"
              />
            }
            
            <div>
              <p className="president-msg__name">Dr. David Otwoma.</p>
              <p className="president-msg__role">
                Founding President<br />Nuclear Society of Kenya
              </p>
              <span className="president-msg__badge">Founding Member</span>
            </div>
          </div>

          {/* Message content */}
          <div className="president-msg__content">
            <div aria-hidden="true" className="president-msg__quote-mark">"</div>
            <p className="president-msg__label">Message from the Founding President</p>
            <h2 className="president-msg__heading" id="president-heading">
              Building a Nuclear Future, One Conversation at a Time
            </h2>

            <div className="president-msg__body">
              <p>
                Greetings and Welcome to the Nuclear Society of Kenya’s (NSK) Webpage. NSK is 
                a registered entity under the Society’s Act of Kenya and has been set up to 
                bring together professionals who are scientists, engineers and technologists 
                in Kenya, together under one roof.


              </p>
              <p>
                Members of NSK will come from the academic world, research centers, private 
                industry and public entities. It will be composed of people who will voluntarily
                commit themselves to generate ideas and to take up responsibilities, have the 
                enthusiasm to get things done and the curiosity to learn from their colleagues 
                and from stakeholders.
              </p>
              <p>
                Organizations that have nuclear scientists, engineers and technologists and
                that has national activities working with radiation will be eligible to become
                members. Any entities operating in the nuclear space –be it a scientific or a 
                technical institute, a cultural foundation, a university or an industrial venture– 
                will be eligible to become a “Corporate Member” of NSK.
              </p>
              <p>
                At COP 28 twenty five (25) countries committed to tripling global nuclear capacity
                by 2050 so as to adhere to Paris declaration. Energy poverty is a reality in Kenya
                that we need to confront, first by recognizing that our per capita electricity 
                consumption is around 190 kWh, which is paltry when we compare ourselves say with 
                South Korea who are at average of 10,273 kWh.South Korea can completely be self-sufficient
                with domestically produced energy yet they do not boast of any locally available natural resources unlike us! 
              </p>
              <p>
                Despite the nuclear community currently being faced with multiple hurdles, NSK will work with
                urgency for Kenya to adopt nuclear technology development through the collective effort of its
                members and its international partners. Technology transfer is a significant hurdle that we will
                grapple with as we have the human resource ready to absorb the knowledge.
                NSK will endeavor to promote the advancement of nuclear science and the technology together with
                other sciences and arts. The organization will also aid in the integration of the several disciplines
                constituting nuclear science, engineering and technology.
             </p>
             <p>
                We will also aim to create awareness amongst general public about the benefits of atomic energy by 
                conducting several village “barazas” aka town hall meetings about nuclear energy and its applications. 
                This activity will mainly be organized for students and faculty of academic institutions who will be 
                interacted with through lectures. NSK will also prepare and disseminate information related to nuclear 
                science, engineering and technology through journals, books, pamphlets, reports and other information 
                media appropriate to a scientific and technical society notably social digital platforms.
             </p>
             <p>
                NSK will co-operate with government agencies, educational institutions, and other organizations having 
                the same or similar purposes for the realization of having a domestic nuclear energy program supplying 
                cheap, reliable and practically renewable energy into Kenya’s mix. We will advocate for adoption of 
                nuclear energy as the realistic future is one where nuclear assists our country and others in the region 
                achieve net zero while assuring the population has access to reliable and affordable electricity.
             </p>
             <p>
                With its current headquarters at Nairobi, we expect NSK to grow into branches and spread out into the 
                Counties thus guaranteeing inclusivity. Let us all join hands in realizing this noble task within our lifetime.
             </p> 
             <p>
                Karibu na Asante Sana!
             </p>
             <div className="footer__socials">
              <a
                href="https://www.linkedin.com/in/david-otwoma-ab004466/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
                aria-label="Founding President on LinkedIn"
          >
            <FaLinkedinIn size={24} />
            </a>
            </div>
            </div>

            <div className="president-msg__sig">
              <span className="president-msg__sig-name">Dr David Otwoma</span>
              <span className="president-msg__sig-title">
                Founding President, Nuclear Society of Kenya
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mv-section" aria-labelledby="mv-heading">
        <div className="mv-section__inner">
          <div className="mv-section__header">
            <p className="section__label">Who We Are</p>
            <h2 className="section__title" id="mv-heading">
              Mission &amp; Vision
            </h2>
          </div>

          <div className="mv-section__grid">
            {/* Mission card */}
            <div className="mv-card mv-card--mission">
              <div className="mv-card__accent" aria-hidden="true" />
              <div className="mv-card__icon-wrap" aria-hidden="true">
                 <FaBullseye size={26} color="#F59E0B" />
              </div>
              <p className="mv-card__eyebrow">Our Mission</p>
              <h3 className="mv-card__title">What We Do</h3>
              <p className="mv-card__body">
                To promote the safe, secure, and sustainable use of nuclear energy
                and nuclear technology to boost Kenya's socio-economic development —
                connecting professionals, informing policy, and building public
                confidence in the peaceful applications of nuclear science.
              </p>
            </div>

            {/* Vision card */}
            <div className="mv-card mv-card--vision">
              <div className="mv-card__accent" aria-hidden="true" />
              <div className="mv-card__icon-wrap" aria-hidden="true">
                <FaEye size={26} color="#0EA5E9" />
              </div>
              <p className="mv-card__eyebrow">Our Vision</p>
              <h3 className="mv-card__title">Where We Are Headed</h3>
              <p className="mv-card__body">
                A Kenya where nuclear science and technology are fully integrated
                into the national development agenda:- powering homes and industry,
                advancing medicine, and producing a generation of world-class
                Kenyan nuclear professionals.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="values-section" aria-labelledby="values-heading">
        <div className="values-section__inner">
          <div className="values-section__header">
            <p className="section__label">What We Stand For</p>
            <h2 className="section__title" id="values-heading">
              Our Core Values
            </h2>
            <p className="section__subtitle" style={{ marginTop: 'var(--space-3)' }}>
              These four principles shape every programme, partnership, and publication
              that NSK delivers.
            </p>
          </div>

          <div className="values-grid">
            {CORE_VALUES.map(({ icon, title, text }) => (
              <article className="value-card" key={title}>
                <div className="value-card__icon" aria-hidden="true">
                  {icon}
                </div>
                <h3 className="value-card__title">{title}</h3>
                <p className="value-card__text">{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Core Goals */}
      <section className="goals-section" aria-labelledby="goals-heading">
        <div className="goals-section__inner">

          {/* Left — text */}
          <div className="goals-section__content">
            <p className="goals-section__eyebrow">What We Stand For</p>
            <h2 className="goals-section__title" id="goals-heading">
              Core Goals
            </h2>
            <p className="goals-section__body">
              The Nuclear Society of Kenya is a professional, non-profit organisation.
              It unites professionals, students, and the public to promote the peaceful
              use of nuclear science and technology to improve Kenya's economy and society.
              To achieve its mission, the society focuses on three strategic areas.
            </p>
            <Link to="/membership" className="btn btn--primary" style={{ alignSelf: 'flex-start' }}>
              Become a Member
            </Link>
          </div>

          {/* Right — numbered goal list */}
          <ol className="goals-list" aria-label="NSK Core Goals">
            {GOALS.map(({ label, desc }, index) => (
              <li className="goals-list__item" key={label}>
                <span className="goals-list__number" aria-hidden="true">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div className="goals-list__text">
                  <span className="goals-list__label">{label}</span>
                  <span className="goals-list__desc">{desc}</span>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* Affiliations Strip */}
      <section className="affiliations" aria-label="NSK affiliations and partners">
        <div className="affiliations__inner">
          <p className="affiliations__label">Partners &amp; Affiliations</p>
          <div className="affiliations__logos">
            {AFFILIATIONS.map(({ label, href }) => (
              <a
                key={label}
                href={href}
                className="affiliations__item"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Visit ${label} website`}
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta" aria-labelledby="about-cta-heading">
        <div className="about-cta__inner">
          <h2 className="about-cta__title" id="about-cta-heading">
            Be Part of Kenya's{' '}
            <span>Nuclear Story</span>
          </h2>
          <p className="about-cta__text">
            Whether you are a student, researcher, engineer, or policy professional —
            NSK has a place for you. Join us and help shape the future of nuclear
            science in Kenya.
          </p>
          <div className="about-cta__actions">
            <Link to="/join" className="btn btn--primary">
              Join NSK
            </Link>
            <Link to="/team" className="btn btn--outline">
              Meet Our Team
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;